export const DefaultLocale = process.env.APP_LOCALE || 'en';

export const AwsConfig = {
    API_AM: 'AM',
    API_CM: 'CM',
    API_EHSS: 'EHSS',
    API_CONFIG: 'CONFIG',
    API_QA: 'QA',
    API_QAFS: 'QAFS',
    API_LI: 'LI',
    DEV: 'DEV'
};
